var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3D47",
    d: "M27.698 8.2c-.4-.5-3.9-.5-3.5-.7l-4.9 2.9-7.3-2.3-2.1 1 4.9 4-4.9 3-2.3-1.1-2.2 1.3 3.3 2.3 2.8.1 14.5-8c.8-1 2.1-2 1.7-2.5zM5.1 21.529H27v1.4H5.1z"
  })));
}
export default SvgFtAirplane;